import React from 'react';
import PropTypes from 'prop-types';
import { PlayActionWrapper, PlayActionEvent, PlayActionDescription } from './PlayAction.style';

const PlayAction = ({
    event,
    description,
    isLoading
}) => {
    if (event || description) {
        return (
            <PlayActionWrapper
                multipleChildren={ event && description }
            >
                {
                    event && <PlayActionEvent>
                        { event }
                    </PlayActionEvent>
                }
                {
                    description && <PlayActionDescription>
                        { description }
                    </PlayActionDescription>
                }
            </PlayActionWrapper>
        );
    }
};

PlayAction.propTypes = {
    event: PropTypes.string,
    description: PropTypes.string
};

export default PlayAction;
